import { AreaType } from "Models/map";
import { MapData } from "pages/Map";
import React, { useState } from "react";
import { CSSTransition } from "react-transition-group";
import MenuTab from "../MenuTab";
import MenuDisplay from "./Containers/MenuDisplay";
import MenuInformation from "./Containers/MenuInformation";
import "./index.scss";

type MapInputPropsType = {
  wardData: any;
  externalFoodAndBeverageCategories: MapData;
  externalFoodAndBeverageData: MapData;
  externalFoodAndBeverageDeliveryData: MapData;
  staticDemandData: MapData;
  externalRetailData: MapData;
  nearbyLocationSummary: MapData;
  selectedLocationType: Array<number>;
  selectedBrand: Array<number>;
  onChange: (
    selectedLocationType: Array<number>,
    selectedBrand: Array<number>
  ) => void;
  brandObj: { [key: string]: any };
  getNewBrand: (brand: any) => void;
  toggleZone: (enable: boolean) => void;
  enableZone: boolean;
  enablePopulate: boolean;
  togglePopulate: (enable: boolean) => void;
  enableArea: boolean;
  toggleArea: (enable: boolean) => void;
  enableRetailData: boolean;
  fetchRetailData: () => void;
  enableFoodAndBeverageData: boolean;
  fetchFoodAndBeverageData: () => void;
  enableFoodAndBeverageDeliveryData: boolean;
  fetchFoodAndBeverageDeliveryData: () => void;
  onChangeMapType: (id: string) => void;
  mapTypeId: string;
  selectedZone: any;
  toggleSitePlanningCommentUI: () => void;
  editPlanningPolygon: () => void;
  setCurrentMapDrawer: (drawer: any) => void;
  currentMapDrawer: any;
  embedMode?: boolean;
  enableStaticData: boolean;
  fetchStaticData: () => void;
  onSelectedAreaType: (id: AreaType) => void;
  areaType: AreaType;
  openPlanningZoneListing: () => void;
  isRadiusMode: boolean;
  setRadiusMode: (radius: boolean) => void;
  radiusVal: number;
  setRadiusVal: (val: number) => void;
  onRadiusCompleted: () => void;
  foodAndBeverageLoading: boolean;
  foodAndBeverageDeliveryLoading: boolean;
  staticLoading: boolean;
  retailLoading: boolean;
};

const MapRightMenu = ({
  selectedBrand,
  selectedLocationType,
  onChange,
  brandObj,
  getNewBrand,
  toggleZone,
  enableZone,
  enableArea,
  enableFoodAndBeverageData,
  enableFoodAndBeverageDeliveryData,
  enablePopulate,
  enableRetailData,
  toggleArea,
  fetchFoodAndBeverageData,
  fetchFoodAndBeverageDeliveryData,
  togglePopulate,
  fetchRetailData,
  mapTypeId,
  onChangeMapType,
  selectedZone,
  editPlanningPolygon,
  toggleSitePlanningCommentUI,
  currentMapDrawer,
  setCurrentMapDrawer,
  embedMode,
  enableStaticData,
  fetchStaticData,
  externalFoodAndBeverageCategories,
  externalFoodAndBeverageData,
  externalFoodAndBeverageDeliveryData,
  externalRetailData,
  staticDemandData,
  wardData,
  nearbyLocationSummary,
  areaType,
  onSelectedAreaType,
  openPlanningZoneListing,
  isRadiusMode,
  setRadiusMode,
  radiusVal,
  setRadiusVal,
  onRadiusCompleted,
  foodAndBeverageLoading,
  foodAndBeverageDeliveryLoading,
  staticLoading,
  retailLoading,
}: MapInputPropsType) => {
  const [currentIndex, setIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(!embedMode);
  const [opened, setOpened] = useState(!embedMode);
  const toggle = () => setIsOpen(!isOpen);
  const toggleOpened = () => setOpened(!opened);
  return (
    <div style={{ display: "flex" }}>
      {!opened && (
        <div
          className="base-map__toggle-button normal-button"
          onClick={toggle}
          //   onMouseEnter={toggle}
        >
          <i className="material-icons">menu</i>
        </div>
      )}
      <CSSTransition
        in={isOpen}
        timeout={300}
        classNames="menu-right"
        unmountOnExit
        onEnter={toggleOpened}
        onExited={toggleOpened}
      >
        <div style={{ display: "flex" }}>
          <div className="base-map__menu-off-button" onClick={toggle}>
            <i className="material-icons">arrow_forward_ios</i>
          </div>
          <div
            className={`base-map__right-menu${
              embedMode ? " right-menu__embed-mode" : ""
            }`}
          >
            <MenuTab
              embedMode={embedMode}
              initialIndex={currentIndex}
              onTabChanged={(index) => setIndex(index)}
              items={[
                {
                  icon: "dashboard",
                  scene: (
                    <MenuInformation
                      embedMode={embedMode}
                      openPlanningZoneListing={openPlanningZoneListing}
                      areaType={areaType}
                      onSelectedAreaType={onSelectedAreaType}
                      externalFoodAndBeverageCategories={
                        externalFoodAndBeverageCategories
                      }
                      externalFoodAndBeverageData={externalFoodAndBeverageData}
                      externalFoodAndBeverageDeliveryData={
                        externalFoodAndBeverageDeliveryData
                      }
                      externalRetailData={externalRetailData}
                      staticDemandData={staticDemandData}
                      wardData={wardData}
                      toggleZone={toggleZone}
                      enableZone={enableZone}
                      enableArea={enableArea}
                      enableFoodAndBeverageData={enableFoodAndBeverageData}
                      enableFoodAndBeverageDeliveryData={
                        enableFoodAndBeverageDeliveryData
                      }
                      enablePopulate={enablePopulate}
                      enableRetailData={enableRetailData}
                      toggleArea={toggleArea}
                      fetchFoodAndBeverageData={fetchFoodAndBeverageData}
                      fetchFoodAndBeverageDeliveryData={
                        fetchFoodAndBeverageDeliveryData
                      }
                      togglePopulate={togglePopulate}
                      fetchRetailData={fetchRetailData}
                      mapTypeId={mapTypeId}
                      onChangeMapType={onChangeMapType}
                      selectedZone={selectedZone}
                      editPlanningPolygon={editPlanningPolygon}
                      toggleSitePlanningCommentUI={toggleSitePlanningCommentUI}
                      currentMapDrawer={currentMapDrawer}
                      setCurrentMapDrawer={setCurrentMapDrawer}
                      enableStaticData={enableStaticData}
                      fetchStaticData={fetchStaticData}
                      isRadiusMode={isRadiusMode}
                      setRadiusMode={setRadiusMode}
                      radiusVal={radiusVal}
                      setRadiusVal={setRadiusVal}
                      onRadiusCompleted={onRadiusCompleted}
                      foodAndBeverageLoading={foodAndBeverageLoading}
                      foodAndBeverageDeliveryLoading={
                        foodAndBeverageDeliveryLoading
                      }
                      staticLoading={staticLoading}
                      retailLoading={retailLoading}
                    />
                  ),
                },
                {
                  icon: "filter_alt",
                  scene: (
                    <MenuDisplay
                      selectedBrand={selectedBrand}
                      selectedLocationType={selectedLocationType}
                      onChange={onChange}
                      brandObj={brandObj}
                      getNewBrand={getNewBrand}
                      nearbyLocationSummary={nearbyLocationSummary}
                    />
                  ),
                },
              ]}
            />
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default MapRightMenu;
